import type {PropsWithChildren} from 'react'

export function App({children}: PropsWithChildren) {
  return <>{children}</>
}
